export interface Section {
  id: string;
  path: string;
  label: string;
}

export const sections: Section[] = [
  { id: 'home', path: '/', label: 'Home' },
  { id: 'experience', path: '/experience', label: 'Experience' },
  { id: 'contact', path: '/contact', label: 'Contact' },
  { id: 'side-projects', path: '/side-projects', label: 'Side Projects' },
];

const topNavSectionPaths = new Set(['/', '/experience', '/contact']);

export const navLinks = sections
  .filter(({ path }) => topNavSectionPaths.has(path))
  .map(({ path, label }) => ({
  to: path,
  label,
  }));
